import { c as _c } from "react/compiler-runtime";
import { type Ref } from 'react';
import { Row as AntRow } from 'antd';
import type { RowProps } from 'antd/es/grid';
import cx from 'classnames';
import './styles.scss';
export type { RowProps };
const AppColClassName = 'app-row';

/**
 * This class is a wrap around [antd Col](https://ant.design/components/grid/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 */
export function Row(t0) {
  const $ = _c(10);
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cx(AppColClassName, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== ref || $[8] !== t1) {
    t2 = <AntRow ref={ref} {...props} className={t1} />;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}